import type { Feature, Requirement } from 'components/framework/models';
import RecordAction from '../RecordAction';
import terminology from 'javascripts/terminology';
import type ApplicationModel from 'components/framework/ApplicationModel';

type RecordType = Feature | Requirement;

export class AssignToCurrentIteration extends RecordAction<RecordType> {
  recordTypes = ['Feature', 'Requirement'];

  get title() {
    return `Assign to current ${terminology('iteration')} (${
      window.currentIteration.name
    })`;
  }

  showForRecord(record: ApplicationModel): record is RecordType {
    if (!super.showForRecord(record)) {
      return false;
    }

    const isTeamAssignable =
      'assignToTeam' in record && typeof record.assignToTeam === 'function';
    const currentProjectIsTeam = window.currentProject?.isTeam;
    const hasCurrentIteration = window.currentIteration?.id;
    const isNotAssignedToCurrentIteration =
      record.iteration?.id !== window.currentIteration?.id;

    return !!(
      window.currentProject?.id &&
      isTeamAssignable &&
      currentProjectIsTeam &&
      hasCurrentIteration &&
      isNotAssignedToCurrentIteration
    );
  }

  async runForRecords(records) {
    const team = { id: window.currentProject?.id };
    const iteration = { id: window.currentIteration.id };

    await Promise.all(
      records.map(async record => {
        if (record.team?.id !== team.id) {
          await record.assignToTeam(team, { resetAttributes: true });
        }

        return record.update(
          { iteration },
          { args: { __reactivelyUpdate: true } }
        );
      })
    );
  }
}
